import AxiosUtils, { request } from 'Resources/AxiosUtils';
import { JSONType } from 'Typings/Global';
import { parseResource, parseResourceFormData } from 'Models/Resource/resourceParsers';
import { TResource } from 'Models/Resource/@types';


class SoundtrackModel {

  static getAllSoundtracks = async (params?: Record<string, any>): Promise<JSONType[]> => {
    const res = await request<JSONType[]>({
      url: '/Soundtracks',
      method: 'GET',
      params,
    });
    return res.map(parseResource);
  };

  static getSoundtrack = async (id: string, params?: Record<string, any>): Promise<TResource> => {
    const res = await request<JSONType>({
      url: `/resources/${id}/find/Soundtrack`,
      method: 'GET',
      params,
    });
    return parseResource(res);
  };

  static updateSoundtrack = async (data: Partial<TResource> & { id: string }): Promise<TResource> => {
    const res = await request({
      url: `/soundtracks/${data.id}`,
      method: 'patch',
      data: { ...parseResourceFormData(data) },
    }).catch(AxiosUtils.throwError);
    if (!res) return Promise.reject();
    return { ...data, ...parseResource(res) } as TResource;
  };

  static deleteSoundtracks = async (ids: string[]): Promise<JSONType> => {
    const res = await request<JSONType>({
      url: '/soundtracks/trash',
      method: 'DELETE',
      data: { ids },
    });
    return res;
  };

  static togglePublishSoundtrack = (id: string, publish: boolean): Promise<JSONType> =>
    request<JSONType>({
      url: `/soundtracks/${id}/publish`,
      method: 'post',
      params: { publish },
    });
}

export default SoundtrackModel;
